import { api } from './api';

export interface InboxThread {
  id: string;
  workspaceId: string;
  contactId: string | null;
  accountId: string | null;
  subject: string | null;
  lastMessageAt: string | null;
  sentiment: number | null;
  participants: string[];
  provider: string | null;
  providerThreadId: string | null;
  createdAt: string;
}

export interface InboxMessage {
  id: string;
  threadId: string;
  direction: 'in' | 'out';
  fromAddr: string | null;
  toAddrs: string[] | null;
  body: string | null;
  sentAt: string | null;
  composedByAi: boolean;
  aiRunId: string | null;
  providerMsgId: string | null;
}

export const inboxApi = {
  listThreads: async (params: {
    workspaceId: string;
    contactId?: string;
    accountId?: string;
    search?: string;
    limit?: number;
    offset?: number;
  }) => {
    const r = await api.get<{ items: InboxThread[]; total: number }>(
      '/api/inbox/threads',
      { params },
    );
    return r.data;
  },
  getThread: async (id: string) => {
    const r = await api.get<{ thread: InboxThread; messages: InboxMessage[] }>(
      `/api/inbox/threads/${id}`,
    );
    return r.data;
  },
  seedDemo: async (workspaceId: string) => {
    const r = await api.post<{ inserted: number; items: InboxThread[] }>(
      '/api/inbox/seed-demo',
      { workspaceId },
    );
    return r.data;
  },
};
